/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles5} from "../../util/TableStyles"
import { useStyles } from "../../util/ComponentStyles";
import { noDataComponent } from "../../util/DataObject"
import { Card } from "@albo-ui/core";

const DefaultInit = (props) => {
  const [data, setData] = useState([]);
  const [column, setColumn] = useState([]);
  const clasess = useStyles();

  useEffect(() => {
    setData(JSON.parse(JSON.stringify(props.item.data.content)));
    setColumn(JSON.parse(JSON.stringify(props.item.data.columns)));
  }, [props.item.data.content]);

  const clickOpenEmail = (item) => {
    let request = item.uuid;

    for (let i = 0; i < column.length; i++) {
      if (column[i].hasOwnProperty("object")) {
        request = column[i].object;
        request[column[i].objectKey] = data[column[i].objectKey];
      }
      if (column[i].hasOwnProperty("openEmail")) {
        localStorage.setItem("valueSearch", item.email);
        props.addWidget( column[i].openEmail, request, ["changeEmail"], item.email);
      }
      if (column[i].hasOwnProperty("openModal")) {
        localStorage.setItem("valueSearch", item.email);
        props.addWidget( column[i].openModal, request, ["modal"], item.email);
      }
    }
  };

  const columns = []
  if(data.length !== 1){
    columns.push(
      { cell: (item) => {
        return (
          <div>
            <a href="#" data-tag="allowRowEvents" onClick={clickOpenEmail.bind(this, item)}>
              <VisibilityIcon />
            </a>
          </div>
        );
        },
        sortable: true, wrap: true, maxWidth: "20px",
      })}
  
  columns.push(
    { selector: (row) => row.name, name: "Nombre", sortable: true, wrap: true },
    { selector: (row) => row.email, name: "Email", sortable: true, wrap: true },
    { selector: (row) => row.uuid, name: "UUID", width: "40%", sortable: true, wrap: true },
    { selector: (row) => row.status, name: "Estatus", width: "10%", sortable: true, wrap: true },
  )

  return (
		<Card flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: "white", marginBottom: 25, padding: 0, boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px'}}>
      <ThemeProvider theme={theme}> 
        <DataTable columns={columns} data={data} customStyles={customStyles5} noDataComponent={noDataComponent}/>
      </ThemeProvider>
    </Card>
  );
};

export default DefaultInit;
